import { createRouter, createWebHashHistory } from 'vue-router'
import ProtocolList from '../views/ProtocolList.vue'

const routes = [
  {
    path: '/',
    name: 'ProtocolList',
    component: ProtocolList
  },
  {
    path: '/policy',
    name: 'PolicyPage',
    // 路由懒加载
    component: () => import('../views/Policy.vue')
  },
  {
    path: '/user',
    name: 'UserPage',
    // 路由懒加载
    component: () => import('../views/User.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
